import React, { useEffect, useRef, useState } from "react";
import PrimaryBtn from "../../Buttons/PrimaryBtn";
import SearchBar from "../../Search/SearchBar";
import UploadFile from "./UploadFile";
import {
  ActiveGridIcon,
  DateIcon,
  FilterIcon,
  InactiveGridIcon,
  ListActiveIcon,
  ListInactiveIcon,
  RefreshIcon,
} from "../Icons";
import MyDateRangePicker from "./MyDateRangePicker";
import { DateRangePicker } from "react-date-range";
import { Tooltip } from "@mui/material";

const DISABLED_UPLOAD_MSG = "Lower School lessons does not support file uploads";

const Header = ({
  handleRefresh = null,
  searchParam,
  setSearchParam,
  clickFilter = null,
  btnLabel = "Upload",
  title = null,
  activeView = "file",
  setActiveView,
  searchPlaceholder = "Search",
  currentFolder,
  isModal = false,
  handleDateChange = null,
  isAiFolder = false,
  justify = null,
  type,
  currentLessonFolder,
  id,
  onUploadComplete = null,
  path,
  data,
  // Lets the caller disable uploads before the backend knows the folder is lower school
  forceDisableUpload = false,
}) => {
  const [uploadFilePopup, setUploadFilePopup] = useState(false);
  // Uploads are not allowed inside lower school folders
  const disableUpload =
    forceDisableUpload || !!data?.current_folder?.lower_school;
  const [openDate, setOpenDate] = useState(false);
  const dateRef = useRef(null);
  const [range, setRange] = useState([
    { startDate: undefined, endDate: undefined, key: "selection" },
  ]);

  const changeView = (view) => {
    setActiveView(view);
    return;
  };

  const dateChange = (value) => {
    setRange(value);
    handleDateChange(value);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dateRef.current && !dateRef.current.contains(event.target)) {
        setOpenDate(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  return (
    <div className="flex flex-col px-2 md:px-0 md:flex-row md:items-center md:justify-between gap-2 md:gap-3 w-full mt-3 md:mt-0">
      {title ? (
        <div className="flex flex-col md:flex-row md:items-center md:gap-3 w-full">
          <div className="flex items-center justify-between">
            <div
              role="heading"
              aria-level="1"
              className={`flex items-center text-black ${!isModal
                ? "text-[1.2rem] font-medium"
                : "text-[0.9rem] font-normal"
                }  font-medium`}
            >
              {title}
            </div>
            {window.innerWidth < 640 &&
              btnLabel &&
              +currentFolder?.id !== 1 &&
              !isAiFolder && (
                <div className="relative">
                  {/* Tooltip anchors on the wrapper: a disabled button doesn't fire hover events. */}
                  <Tooltip
                    title={disableUpload ? DISABLED_UPLOAD_MSG : ""}
                    placement="top"
                    arrow
                  >
                    <span className="inline-flex">
                  <PrimaryBtn
                    handleClick={() => {
                      setUploadFilePopup(true);
                    }}
                    iconPosition="right"
                    label={btnLabel}
                    disabled={disableUpload}
                  // icon={
                  //   <svg
                  //     width="15"
                  //     height="15"
                  //     viewBox="0 0 15 15"
                  //     fill="none"
                  //     xmlns="http://www.w3.org/2000/svg"
                  //   >
                  //     <path
                  //       d="M6.66667 15V8.33333H0V6.66667H6.66667V0H8.33333V6.66667H15V8.33333H8.33333V15H6.66667Z"
                  //       fill="white"
                  //     />
                  //   </svg>
                  // }
                  />
                    </span>
                  </Tooltip>
                  <UploadFile
                    showUploadPop={uploadFilePopup}
                    setShowUploadPop={setUploadFilePopup}
                    currentFolder={currentFolder}
                    type={type}
                    currentLessonFolder={currentLessonFolder}
                    id={id}
                    onUploadComplete={onUploadComplete}
                    data={data}
                  />
                </div>
              )}
          </div>
          <SearchBar
            search={searchParam}
            setSearch={setSearchParam}
            placeholder={searchPlaceholder}
            filterSort={false}
            width={window.innerWidth < 650 ? "w-full" : "w-[60%]"}
            contMargin="m-0"
            inputWidth="w-full"
          />
        </div>
      ) : (
        <SearchBar
          search={searchParam}
          setSearch={setSearchParam}
          filterSort={false}
          width="w-[60%]"
          contMargin="m-0"
          inputWidth="w-full"
        />
      )}
      <div
        className={`flex items-center min-w-fit gap-2 ${justify}`}
      >
        {handleDateChange && (
          <div ref={dateRef} className="p-0 min-w-fit">
            <MyDateRangePicker
              range={range}
              setRange={dateChange}
              isOpen={openDate}
              isHeader={true}
              toggleComponent={() => setOpenDate((prev) => !prev)}
              onRangeSelect={handleDateChange}
            />
          </div>
        )}
        {window.innerWidth >= 640 &&
          btnLabel &&
          +currentFolder?.id !== 1 &&
          !isAiFolder && (
            <div className="relative">
              {/* Tooltip anchors on the wrapper: a disabled button doesn't fire hover events. */}
              <Tooltip
                title={disableUpload ? DISABLED_UPLOAD_MSG : ""}
                placement="top"
                arrow
              >
                <span className="inline-flex">
              <PrimaryBtn
                handleClick={() => {
                  setUploadFilePopup(true);
                }}
                iconPosition="right"
                label={btnLabel}
                disabled={disableUpload}
              // icon={
              //   <svg
              //     width="15"
              //     height="15"
              //     viewBox="0 0 15 15"
              //     fill="none"
              //     xmlns="http://www.w3.org/2000/svg"
              //   >
              //     <path
              //       d="M6.66667 15V8.33333H0V6.66667H6.66667V0H8.33333V6.66667H15V8.33333H8.33333V15H6.66667Z"
              //       fill="white"
              //     />
              //   </svg>
              // }
              />
                </span>
              </Tooltip>
              <UploadFile
                showUploadPop={uploadFilePopup}
                setShowUploadPop={setUploadFilePopup}
                currentFolder={currentFolder}
                type={type}
                currentLessonFolder={currentLessonFolder}
                id={id}
                onUploadComplete={onUploadComplete}
                path={path}
                data={data}
              />
            </div>
          )}
        {handleRefresh && (
          <button
            onClick={handleRefresh}
            className="border-none bg-transparent flex items-center gap-2"
          >
            <RefreshIcon />
            <span className="text-[#1F1F1F] text-[0.9rem] font-normal">
              Refresh
            </span>
          </button>
        )}
        {clickFilter && (
          <button
            className="bg-transparent border-none flex items-center gap-2"
            onClick={clickFilter}
          >
            <FilterIcon />
            <span className="text-[#1F1F1F] text-[0.9rem] font-normal">
              Filter
            </span>
          </button>
        )}

        {setActiveView ? (
          <div className="flex items-center gap-[2] border border-[#D9D9D9] rounded p-2">
            {activeView === "file" ? (
              <>
                <Tooltip title="List View">
                  <button className="bg-transparent border-none">
                    <ListActiveIcon w="24" h="24" />
                  </button>
                </Tooltip>
                <Tooltip title="Tiles View">
                  <button
                    onClick={() => changeView("grid")}
                    className="bg-transparent border-none"
                  >
                    <InactiveGridIcon w="24" h="24" />
                  </button>
                </Tooltip>
              </>
            ) : (
              <>
                <Tooltip title="List View">
                  <button
                    onClick={() => changeView("file")}
                    className="bg-transparent border-none"
                  >
                    <ListInactiveIcon w="24" h="24" />
                  </button>
                </Tooltip>
                <Tooltip title="Tiles View">
                  <button className="bg-transparent border-none">
                    <ActiveGridIcon w="24" h="24" />
                  </button>
                </Tooltip>
              </>
            )}
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default Header;